import { render } from "./applicant.vue?vue&type=template&id=3fe8765f&ts=true"
import script from "./applicant.vue?vue&type=script&lang=ts"
export * from "./applicant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__